//#region Util Imports

import * as _ from 'underscore'
import moment = require('moment')

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import Component from 'devextreme/core/component'

//#endregion

//#region IMR Imports

import { IMRPopupOptions, IIMRPopup } from '@imr/controls.angularjs/components/overlay/popup'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'

//#endregion

import { UserSessionService } from "../../../../../services/user-session"

import { LocalizationHelper, ConfigHelper, ConvertHelper, TypeHelper } from "../../../../../helpers"

import { Enums, Activity } from "../../../../../models/common"
import { Measure } from "../../../../../models/custom/measure"
import { MeasureCollection } from "../../../../../models/custom"

import { GridController, GridOptions, GridTypes } from "../../../grid"
import { HistorySource } from "../../../history"
import { IMRBaseControlController } from "../../../base"

import { IMRAccordionItemOptions, IMRAccordionOptions } from "../../../accordion"
import { ValveManageOptions, IValveManage } from "./action-run.dedicated.valve-manage.interfaces"
import { ValveManageService } from "./services/valve-manage.service"
import { FieldModel, CorrespondingActionTypeModel } from '../../../../api/api.models'
import { IHistory } from '../../../history/history.directive.controller'

export class ValveManageController extends IMRBaseControlController<IValveManage, ValveManageOptions> implements ng.IComponentController, IValveManage {

    public get HISTORY_GRID_NAME(): string { return 'valveManageHistoryGridName' }
    public get STATUS_GRID_NAME(): string { return 'valveManageHistoryGridName' }
    public get LOG_PREFIX(): string { return '[SIMAX.Common.ACTION-RUN.DEDICATED.VALVE-MANAGE]' }

    public popupOptions: IMRPopupOptions
    public historyOptions: HistorySource
    public showLoader: boolean = false

    public showActionRunOptions: boolean
    public showStatusGridLoader: boolean

    public radioGroupOptions: DevExpress.ui.dxRadioGroupOptions
    public radioGroup: DevExpress.ui.dxRadioGroup

    public dateBoxOptions: DevExpress.ui.dxDateBoxOptions
    public dateBox: DevExpress.ui.dxDateBox

    public runActionButtonOptions: DevExpress.ui.dxButtonOptions

    public planActionRunCheckBoxOptions: DevExpress.ui.dxCheckBoxOptions
    private planActionRunCheckBox: DevExpress.ui.dxCheckBox

    public notesTextAreaOptions: DevExpress.ui.dxTextAreaOptions
    private notesTextArea: DevExpress.ui.dxTextArea

    public accordionOptions: IMRAccordionOptions
    public historyAccordionOptions: IMRAccordionOptions


    public valveStateAccordionItemOptions: IMRAccordionItemOptions

    public valveControlAccordionItemOptions: IMRAccordionItemOptions

    public historyGridAccordionItemOptions: IMRAccordionItemOptions

    public options: ValveManageOptions

    public notesCheckBoxOptions: DevExpress.ui.dxCheckBoxOptions
    private notesCheckbox: DevExpress.ui.dxCheckBox;
    private action: CorrespondingActionTypeModel;
    private historyGridController: GridController<any>
    private historyInterface: IHistory
    private intervalId: any
    private isGridFixed: boolean = false
    private popup: IIMRPopup
    private refreshHistoryCheckBox: DevExpress.ui.dxCheckBox
    private statusGrid: GridController<any>
    public statusGridOptions: GridOptions

    constructor(private valveManageService: ValveManageService, private userSessionService: UserSessionService) {
        super()
    }

    protected initialize(options: ValveManageOptions): JQueryPromise<any> {
        this.setAction(options.action)

        this.initializeNotesTextBoxOptions()
        this.initializeAccordionsOptions()
        this.initializeAccordionItemsOptions()
        this.initializeValveControlWidgets()
        this.initializeStatusGrid()

        return $
            .when(
                this.initializeHistory(),
                this.initializepPopupOptions()
            )
    }

    private onHistoryInitialized(component: IHistory): void {
        this.historyInterface = component
        this.historyGridController = component.getGrid()
        this.historyInterface.isContentReady = () => this.onHistoryContentReady()
    }

    private initializeHistory(): any {
        this.historyOptions = {
            id: null,//DO USUNIECIA!!!
            dataMethodName: null,//DO USUNIECIA!!!
            name: null,//DO USUNIECIA!!!
            allowColumnReordering: false,
            referenceType: Enums.ReferenceType.IdValveState,
            referenceValue: this.options.referenceValues,
            groupingColumn: this.valveManageService.getHistoryGridColumns(),
            onInitialized: (component: IHistory) => this.onHistoryInitialized(component)
        }
    }

    private onHistoryContentReady(): void {
        if (this.isGridFixed == false) {
            setTimeout(() => {
                this.historyGridController.table.repaint()
                this.isGridFixed = true
            }, 500)
        }
    }

    // #region Popup

    private initializepPopupOptions(): JQueryPromise<any> {
        this.popupOptions = {

            innerOptions: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ValveControl),
                deferRendering: false,
                onHiding: () => this.onPopupHiding(),
                fullScreen: true
            },

            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.initializePopup(e.component)
            },
        }

        return super.waitForOnInitialized(this.popupOptions)
    }

    private onPopupHiding(): void {
        this.showLoader = false

        this.clear()
    }

    private clear(): void {
        this.historyOptions = null
        this.dateBoxOptions = null
        this.dateBox = null
        this.dateBoxOptions = null
        this.notesCheckbox = null
        this.notesCheckBoxOptions = null
        this.planActionRunCheckBox = null
        this.planActionRunCheckBoxOptions = null
        this.notesTextArea = null
        this.notesTextAreaOptions = null
        this.radioGroup = null
        this.radioGroupOptions = null
        if (this.intervalId != null) {
            clearInterval(this.intervalId)

            if (this.refreshHistoryCheckBox != null) {
                this.refreshHistoryCheckBox.option('value', false)
            }
        }
    }

    private initializePopup(component: IIMRPopup): void {
        this.popup = component
    }

    // #endregion

    // #region IRMAccordion

    private initializeAccordionsOptions(): void {
        this.accordionOptions = {

        }

        this.historyAccordionOptions = {

        }
    }


    // #endregion


    // #region IMRAccordionItems

    private initializeAccordionItemsOptions(): void {
        this.initializeValveStateAccordionItemOptions()
        this.initializeValveControlAccordionItemOptions()
        this.initializeHistoryGridAccordionItemOptions()
    }

    private initializeValveStateAccordionItemOptions(): void {
        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.MEASUREMENTS_LIST)) {
            this.valveStateAccordionItemOptions = {
                expanded: true,
                toolbar: {
                    visible: true,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ValveState)
                }
            }
        }
    }

    private initializeValveControlAccordionItemOptions(): void {
        this.valveControlAccordionItemOptions = {
            expanded: true,
            toolbar: {
                visible: true,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Action),
            }
        }
    }

    private initializeHistoryGridAccordionItemOptions(): void {
        this.historyGridAccordionItemOptions = {
            expanded: true,
            toolbar: {
                visible: true,
                items: [
                    this.getHistoryGridToolbarItem()
                ],
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.History)
            }
        }
    }
    private getHistoryGridToolbarItem(): any {
        let counter: number = 10

        return {
            location: 'after',
            widget: 'dxCheckBox',
            options: {
                onValueChanged: (e: any) => {
                    counter = this.onHistoryGridToolbarCheckBoxClick(e, counter)
                },
                text: LocalizationHelper.getLocalizedText('TimeLeftToRefresh', { collection: 'Popup' }) + ' ' + 10,
                value: false,
                onInitialized: (e: any) => {
                    this.refreshHistoryCheckBox = e.component
                }
            }
        }
    }

    private onHistoryGridToolbarCheckBoxClick(e: any, counter: number): number {
        if (e.value && this.historyInterface != null) {
            if (this.intervalId != null) {
                clearInterval(this.intervalId)
            }
            this.intervalId = setInterval(() => {
                if (counter == 0) {
                    this.historyInterface.refreshData()
                    counter = 10
                }
                counter -= 1
                this.updateRefreshCheckBoxTitle(counter)
            }, 1000)
        } else {
            clearInterval(this.intervalId)
            counter = 10
            this.updateRefreshCheckBoxTitle(counter)
        }
        return counter
    }

    private updateRefreshCheckBoxTitle(counter: number): void {
        const title: string = LocalizationHelper.getLocalizedText('TimeLeftToRefresh', { collection: 'Popup' }) + ' ' + counter

        if (this.refreshHistoryCheckBox != null) {
            this.refreshHistoryCheckBox.option('text', title)
        }
    }

    // #endregion

    // #region AccordionValveControl Toolbar Widgets

    private initializeValveControlWidgets(): void {

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ACTION_RUN_PLAN_OP)) {
            this.initializeActionRunPlanWidgets()
        }

        this.initializeRunActionButton()
        this.initializeNotesCheckbox()
        this.initializeNotesTextBoxOptions()
    }

    private initializeRunActionButton(): void {
        this.runActionButtonOptions = {
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RunActions),
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RunActions),

            onClick: (e: any) => {
                this.runActionButtonClick()
            }
        }
    }

    private runActionButtonClick(): void {
        const fields: FieldModel[] = []

        this.setNoteField(fields)
        this.setScheludeModeFields(fields)

        this.action.fields.push(...fields)
        this.showLoader = true
        this.options.onActionRunClick(this.action)
        this.popup.hide()
    }

    private setScheludeModeFields(fields: FieldModel[]): void {
        if (this.radioGroup != null && this.dateBox != null) {
            const radioValue: { scheduleMode: number, text: string } = this.radioGroup.option('value')

            if (radioValue != null) {
                if (radioValue.scheduleMode === Enums.ActionScheduleMode.ExecuteAtTime || radioValue.scheduleMode === Enums.ActionScheduleMode.WaitForPacket) {
                    fields.push(FieldModel.getFieldModel(Enums.DataType.ACTION_SCHEDULE_TIME, this.dateBox.option('value')))
                }

                fields.push(FieldModel.getFieldModel(Enums.DataType.ACTION_SCHEDULE_MODE, radioValue.scheduleMode))
            }
        }
    }

    private setNoteField(fields: FieldModel[]): void {
        if (this.notesCheckbox != null && this.notesTextArea != null) {
            if (this.notesCheckbox.option('value')) {
                const note: string = this.notesTextArea.option('value')

                if (_.size(note) > 0) {
                    fields.push(FieldModel.getFieldModel(Enums.DataType.ACTION_NOTE, note))
                }
            }
        }
    }

    private initializePlanActionRunCheckBox(): void {
        this.planActionRunCheckBoxOptions = {
            value: false,

            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ScheduleActionExecution),

            onValueChanged: (e: any) => {
                this.showActionRunOptions = e.value
            },
            onInitialized: (e: any) => this.onPlacActionRunCheckBoxInitialized(e)
        }
    }

    private onPlacActionRunCheckBoxInitialized(e: any): void {
        this.planActionRunCheckBox = e.component
    }

    private initializeNotesCheckbox(): void {
        this.notesCheckBoxOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Notes),
            value: false,

            onValueChanged: (e: any) => {
                if (this.notesTextArea != null) {
                    this.notesTextArea.option('visible', e.value)
                }
            },
            onInitialized: (e: any) => {
                this.notesCheckbox = e.component
            }
        }
    }

    private initializeNotesTextBoxOptions(): void {
        this.notesTextAreaOptions = {
            onInitialized: (e: any) => this.onNotesTextBoxInitialized(e),
            visible: false,
            height: '70%',
            width: '100%'
        }
    }

    private onNotesTextBoxInitialized(e: any): void {
        this.notesTextArea = e.component
    }

    // #endregion

    // #region Radio Button Group

    private initializeActionRunPlanWidgets(): void {
        this.initializeDateBoxOptions();
        this.initializeRadioGroup();
        this.initializePlanActionRunCheckBox();
    }

    private initializeRadioGroup(): void {
        this.radioGroupOptions = {
            dataSource: [
                {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExecuteActionAfterReceivingPacket),
                    scheduleMode: Enums.ActionScheduleMode.WaitForPacket
                },
                {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExecuteActionAfterProcessingPacket),
                    scheduleMode: Enums.ActionScheduleMode.WaitForData
                },
                {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExecuteActionAt),
                    scheduleMode: Enums.ActionScheduleMode.ExecuteAtTime,
                }
            ],
            displayExpr: "text",
            value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExecuteActionAt),
            onInitialized: (e: any) => {
                this.radioGroup = e.component
            },
        }
    }

    private initializeDateBoxOptions(): void {
        this.dateBoxOptions = {
            type: "datetime",
            onInitialized: (e: any) => {
                this.dateBox = e.component
            },
            width: '45%',
            displayFormat: ConfigHelper.getDateFormat(ConfigHelper.DateFormat.DATE_TIME_FORMAT_DX),
            disabled: false,
            min: moment().add(10, 'minutes').toDate(),
            value: moment().add(1, 'days').toDate()
        }
    }

    // #endregion

    // #region StatusGrid 

    private initializeStatusGrid(): void {
        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.MEASUREMENTS_LIST)) {
            if (this.statusGridOptions != null) {
                this.getValveState()
                    .then((measures: any[]) => {
                        this.statusGrid.setDataSource(measures)
                        this.showStatusGridLoader = false
                        this.showLoader = false
                    })
            } else {
                this.getValveState()
                    .then((measures: any[]) => {
                        this.statusGridOptions = {
                            type: GridTypes.SMALL,
                            name: this.STATUS_GRID_NAME,
                            buttonsOptions: {
                                enabled: false
                            },
                            columnsDictionary: this.valveManageService.getStatusGridColumns(),
                            dataSource: measures,
                            onInitialized: (e: any, grid: GridController<any>) => this.onStatusGridInitialized(grid),
                        }
                        this.showStatusGridLoader = false
                    })
            }
        }
    }

    private onStatusGridInitialized(grid: GridController<any>): void {
        this.statusGrid = grid
        this.showLoader = false
    }

    private getValveState(): JQueryPromise<any[]> {
        this.showStatusGridLoader = true
        return this.valveManageService.getValveState(this.options.referenceValues)
            .then((measures: MeasureCollection[]) => {
                return measures.map((measureCollection: MeasureCollection) => {

                    const measures: Measure = _.first(measureCollection.measures)

                    return {
                        serialNbr: measureCollection.serialNbr,
                        data: measures != null ? measures.time : null,
                        valveState: ConvertHelper.enumToString(Enums.ValveState, measures.value)
                    }
                })
            })
    }

    // #endregion

    // #region Private Methods

    private setOption(element: Component, option: string, value: any): void {
        if (element != null && element instanceof Component) {
            if (_.isFunction(element.option)) {
                element.option(option, value);
            }
        }
    }

    private getOptionValue<T>(element: Component, option: string): T {
        if (element != null && element instanceof Component) {
            if (_.isFunction(element.option)) {
                return element.option(option);
            }
        }
        return null
    }

    // #endregion


    // #region IValveManage

    public showPopup(): void {
        this.popup.show()
        this.initializeValveControlWidgets()
    }

    public setReferencValues(referenceValues: number[]): void {
        this.options.referenceValues = referenceValues
        this.initializeHistory()
        this.initializeStatusGrid()

    }

    public setAction(action: CorrespondingActionTypeModel): void {
        this.action = TypeHelper.clone(action, true)
    }

    public hidePopup(): void {
        this.popup.hide()
    }

    // #endregion

}